<template>
  <div id="app" :build_number=this.buildNumber>
    <!-- HEADER STARTS -->
    <!-- HEADER ENDS -->
    <!-- CAROUSEL STARTS -->
    <div class="carousel-box">
      <button
        v-if="!this.isMobile && this.totalItems > 0"
        :class="getNext == 0 ? 'disable' : ''"
        @click="onPrevClick"
        class="carousel-action prev"
      >
        <svg width="8" height="14" viewBox="0 0 8 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 0L1.70857e-07 7L8 14L8 0Z" />
        </svg>        
      </button>

      <div v-if="this.totalItems > 0" class="carousel-wrapper">
        <div
          class="carousel-items-container"
          :style="{ 
            transform: 'translateX' + '(' + currentOffset + 'px' + ')',
            transition: `transform ${isTouched ? '0' : '0.25'}s ease-out`
          }"
        >
          <div :class="version == 2 ? 'carousel-item carousel-item--v2' : 'carousel-item'" v-for="(item, i) in items" :key="i" @click="goToRaffle(item)" >
              <div class="carousel-item-inner">
                  <!-- item header -->
                  <div class="header">
                      <div class="first-row">
                          <img :src="item.LogoColour" />
                          <div v-if="item.StatusCd !== 'Closed'">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 16" fill="currentColor">
                                  <path d="M13.58 12.8L10 10.5L6.42 12.8L7.5 8.68L4.21 6L8.46 5.74L10 1.8L11.54 5.74L15.79 6L12.5 8.68L13.58 12.8ZM18 8C18 6.89 18.9 6 20 6V2C20 0.89 19.1 0 18 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V6C1.11 6 2 6.9 2 8C2 8.53043 1.78929 9.03914 1.41421 9.41421C1.03914 9.78929 0.530433 10 0 10V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H18C18.5304 16 19.0391 15.7893 19.4142 15.4142C19.7893 15.0391 20 14.5304 20 14V10C19.4696 10 18.9609 9.78929 18.5858 9.41421C18.2107 9.03914 18 8.53043 18 8Z" />
                              </svg>
                              <span>${{item.BaseTicketPrice.toFixed(2)}}</span>
                          </div>
                          <div v-if="item.StatusCd == 'Closed'">
                              <span class="closed-raffle">Closed</span>
                          </div>
                      </div>
                      <div class="img" :style="{ backgroundImage: `url('${item.OpenGraphImageUrl || item.BackgroundImageUrl}')` }">
                      </div>
                      <div class="info">
                          <div v-if="logo" class="info-item first">
                              <img src="@/assets/vector2.svg" />
                          </div>
                          <!-- <div class="info-item second">
                            <img src="@/assets/vector1.svg" />
                            <p>${{item.BaseTicketPrice | formatNum}} Ticket</p>
                          </div> -->
                      </div>
                  </div>
                  <div class="carousel-content">
                      <p class="title" :title="item.RaffleName">{{item.RaffleName}}</p>
                      <div class="valid-states">
                          <span class="valid-states-title">Valid States:</span>
                          <div class="state-item-lists">
                              <span :class="enabledState(item, 'ACT') ? 'single-state can-buy' : 'single-state'">ACT</span>
                              <span :class="enabledState(item, 'NSW') ? 'single-state can-buy' : 'single-state'">NSW</span>
                              <span :class="enabledState(item, 'NT') ? 'single-state can-buy' : 'single-state'">NT</span>
                              <span :class="enabledState(item, 'QLD') ? 'single-state can-buy' : 'single-state'">QLD</span>
                              <span :class="enabledState(item, 'SA') ? 'single-state can-buy' : 'single-state'">SA</span>
                              <span :class="enabledState(item, 'TAS') ? 'single-state can-buy' : 'single-state'">TAS</span>
                              <span :class="enabledState(item, 'VIC') ? 'single-state can-buy' : 'single-state'">VIC</span>
                              <span :class="enabledState(item, 'WA') ? 'single-state can-buy' : 'single-state'">WA</span>
                          </div>
                      </div>
                      <!-- draw date -->
                      <!-- description -->
                      <!--
                        <p class="description">
                          {{item.RaffleUSP}}
                          <span class="showmore" @click="showOverlay = i">see more</span>
                        </p>
                        -->
                      <!-- buy button -->
                      <p class="drawdate">Drawn: {{ formatDate(item.DrawDt) }} </p>
                      <a :class="item.StatusCd !== 'Closed' ? ' item-link':'item-link item-link__lighter'" href="javascript:void(0);">
                          <button>{{item.StatusCd !== 'Closed'?'BUY TICKETS NOW':'VIEW RESULTS'}}</button>
                      </a>
                  </div>
              </div>
            <!-- description overlay -->
            <div class="overlay" :class="showOverlay == i ? 'show' : ''">
              <div class="overlay-head">
                <span>Description</span>
                <img @click="showOverlay = -1" src="@/assets/back.png">
              </div>
              <div class="description">
                {{item.RaffleUSP}}
              </div>
            </div>
          </div>
        </div>
        <div v-if="isMobile" :class="
          //items.length > 15  ? 'carousel-navigation carousel-navigation__size-more-then-15':
          //items.length > 10 && items.length < 15 ? 'carousel-navigation carousel-navigation__size-more-then-10':          
          'carousel-navigation'
          ">
          <div
            v-for="(item, i) in items" :key="i"
            class="nav-item"
            :class="currentIndex == i ? 'active' : ''"
            @click="onNavigate(i)"
            :style="{
              width: Math.floor((item_width / items.length) * 0.4 ) + 'px', 
              height: Math.floor((item_width / items.length) * 0.4 ) + 'px',
              margin: '0 '+ Math.floor((item_width / items.length) * 0.3 ) + 'px'}"
          ></div>
        </div>
      </div>
      <h1 v-if="!this.isFetching && this.totalItems == 0" class="no-raffles">
        We don't have any raffles yet but watch this space!
      </h1>
      <button
        v-if="!this.isMobile && this.totalItems > 0"
        :class="itemsLeft == 0 ? 'disable' : ''"
        @click="onNextClick"
        class="carousel-action next"
      >
        <svg width="8" height="14" viewBox="0 0 8 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 14L8 7L0 0L0 14Z" />
        </svg>        
      </button>
    </div>
    <!-- CAROUSEL ENDS -->
  </div>
</template>

<script>
import api from 'axios';
import moment from 'moment';

export default {
  name: 'app',
  data() {
    return {
      isFetching: false,
      items: [],
      item_width: window.innerWidth,
      currentOffset: 0,
      touchOffset: 0,
      isTouched: false,
      currentIndex: 0,
      next: 0,
      totalItems: 0,
      isMobile: false,
      navInterval: null,
      dist: 0,
      startX: 0,
      xDiff: 0,
      startY: 0,
      version: 0,
      titles: [
        'Live Raffles',
        'Ending Soon',
        'Our Raffles'
      ],
      apis: [
        '/carousel/popular',
        '/carousel/ending',
        '/carousel/org'
      ],
      innerWidth: 0,
      logo: true,
      showOverlay: -1,
      buildNumber: process.env.VUE_APP_BUILD_NUMBER,
	    org: ''
    }
  },
  mounted() {

    this.configureParameters();

    this.getData();
    if(window.innerWidth > 550)
      window.onresize = this.onWindowResize;

  },
  computed: {
    getNext: function(){
      this.innerWidth;
      return this.next;
    },
    itemsLeft: function(){
      this.innerWidth;
      return this.totalItems - (this.itemsDisplaying() + this.next);
      }
  },
  methods: {
    getData() {
      //let url = this.version == 2 ? this.apis[this.version] + this.org : this.apis[this.version]
      let url = `${process.env.VUE_APP_CAROUSEL_API_BASE}${this.apis[this.version]}?org=${this.org}` ;
      this.isFetching = true;
      api.get(url, {
        transformResponse: [function (data) {
          
          function strAppend(value, extra) {
            if (value && String(value).trim().length > 0) {
              return value + extra;
            }
            return value;
          };

          const tmpData = JSON.parse(data);
          // parse the states and create list of enabledStates
          for(var i = 0; i < tmpData.length; i++){
            const tmpRow = tmpData[i];
            // re-sizer dimensions to logos
            tmpRow.LogoColour = strAppend(tmpRow.LogoColour, '?d=200x60xdefaultx1');
            tmpRow.OpenGraphImageUrl = strAppend(tmpRow.OpenGraphImageUrl, '?d=1000xdefaultx1');
            tmpRow.BackgroundImageUrl = strAppend(tmpRow.BackgroundImageUrl, '?d=1000xdefaultx1');
            
            // avoids multiple parsing;
            tmpRow.DrawDtMoment = moment(tmpRow.DrawDt);

            // support bad data.
            const tmpStates = Array.isArray(tmpRow.ValidStates) ? tmpRow.ValidStates : [];
            tmpRow.enabledStates = tmpStates.map(element => element.Cd);

          }
          return tmpData
        }],
      }
      )
        .then(res => {
         
          if(this.version == 2){
            let recentDate = moment().subtract(30,'days');
            let olderDate = moment().subtract(90,'days');
            
            let activeRaffles = res.data.filter(s=>s.StatusCd != 'Closed').sort((a,b) => a.DrawDtMoment.diff(b.DrawDtMoment));
            let closedRaffles = res.data.filter(a=>!activeRaffles.some(b=>a.RaffleRefCd == b.RaffleRefCd)).sort((a,b) => b.DrawDtMoment.diff(a.DrawDtMoment));
            let recentClosed = closedRaffles.filter(s=>s.DrawDtMoment.isSameOrAfter(recentDate)).sort((a,b) => b.DrawDtMoment.diff(a.DrawDtMoment));
            let olderClosed = closedRaffles.filter(s=>s.DrawDtMoment.isSameOrAfter(olderDate) && s.DrawDtMoment.isBefore(recentDate))
              .sort((a,b) => b.DrawDtMoment.diff(a.DrawDtMoment))
              .slice(0,10);

            this.items = [...activeRaffles, ...recentClosed, ...olderClosed ];
          } else {
            this.items = res.data; 
          }
         
          this.totalItems = this.items.length;
          document.querySelector('#app').classList.add('total-slides' + this.totalItems);
          this.isFetching = false;
          if (this.totalItems > 0) this.onWindowResize(); 
        },
        err => {
          this.isFetching = false;
          // console.log(err);          
        });
    },
    onWindowResize() { 
      this.currentOffset = 0;     
      this.currentIndex = 0;  
      this.next = 0;   
      this.innerWidth = window.innerWidth;
      let width = document.querySelector('.carousel-box').offsetWidth;
      if(width < 630) {
        document.querySelector('#app').classList.add('screen630');
        document.querySelector('#app').classList.remove('screen1100' ,'screen1101');
      }
      else if(width < 1101) {
        document.querySelector('#app').classList.add('screen1100');
        document.querySelector('#app').classList.remove('screen630' ,'screen1101');
      }
      else {
        document.querySelector('#app').classList.add('screen1101');
        document.querySelector('#app').classList.remove('screen630' ,'screen1100');
      }
      if(window.innerWidth <= 630) {
        this.isMobile = true;
        this.$nextTick(function () {
          this.addTouchEvents();  
        });
      }  
      else {
        this.isMobile = false;
        this.$nextTick(function () {
          this.removeTouchEvents();
        });        
      }
    },
    addTouchEvents() {
      let touchSurface = document.querySelector('.carousel-wrapper');
      if (touchSurface) {

        //console.log('addTouchEvents');
        touchSurface.addEventListener('touchstart', this.touchStart, false)

        touchSurface.addEventListener('touchmove', this.touchMove, false)

        touchSurface.addEventListener('touchend', this.touchEnd, false)
      }

    },
    removeTouchEvents() {
      let touchSurface = document.querySelector('.carousel-wrapper');
      if (touchSurface) {
        
        //console.log('removeTouchEvents');
        touchSurface.removeEventListener('touchstart', this.touchStart, false)

        touchSurface.removeEventListener('touchmove', this.touchMove, false)

        touchSurface.removeEventListener('touchend', this.touchEnd, false)
      }
    },
    onPrevClick() {
      if(this.next != 0)
        this.next--;
      
      this.currentOffset = (this.currentOffset + this.scrollFactor());
      if(this.currentOffset > 0) this.currentOffset = 0;
    },
    onNextClick() {
      let itemsLeft = this.totalItems - (this.itemsDisplaying() + this.next);
      if(itemsLeft == 0) return;
        this.next++;
      
      this.currentOffset = (this.currentOffset - this.scrollFactor());
    },
    buildUrl(raffle) {
      let url = raffle.CustomUrl;
      if (url.includes('?')) url += '&';
      else url += '?';
      return url += 'utm_source=carousel&utm_medium=referral&utm_campaign=' + raffle.RaffleRefCd;
    },
    goToRaffle(raffle) {
      const url = this.buildUrl(raffle);
      window.open(url, '_blank');
    },
    enabledState(raffle, stateCd) {
        return raffle.enabledStates.includes(stateCd);
    },
    scrollFactor() {
      let item = document.querySelector('.carousel-item');
      var style = window.getComputedStyle(document.querySelector('.carousel-item'));
      var marginRight = style.getPropertyValue('margin-right'); 

      let wrapper = document.querySelector('.carousel-wrapper');

      let wrapper_width = wrapper.clientWidth;
      let item_width = wrapper_width / this.widthFactor();
      return item_width + parseFloat(marginRight);
    },
    widthFactor() {
      let width = document.querySelector('.carousel-box').offsetWidth;
      let window = {innerWidth: width};
      if(window.innerWidth <= 630)
        return 1;
      else if(window.innerWidth <= 1100)
        return 2.2;
      else return 3.2;
    },
    itemsDisplaying() {
      if(window.innerWidth <= 630)
        return 1;
      else if(window.innerWidth <= 1100) {
       if (this.totalItems <= 2) {
          return this.totalItems; 
        }
        return 2;
      }
      else {
        if (this.totalItems <= 3) {
          return this.totalItems;
        }        
        return 3;
      };
    },
    onNavigate(index) {
      this.currentIndex = index;
      let item = document.querySelector('.carousel-item');
      var style = window.getComputedStyle(document.querySelector('.carousel-item'));
      var marginRight = style.getPropertyValue('margin-right'); 
      let wrapper = document.querySelector('.carousel-wrapper');
      let wrapper_width = wrapper.clientWidth;
      let item_width = wrapper_width / this.widthFactor();
      let scrollFactor = (item_width * (this.itemsDisplaying() - (index + 1))) + parseFloat(marginRight) + 0;      
      this.currentOffset = scrollFactor;
    },
    // touch events
    touchStart(e) {
      this.isTouched = true;
      var touchObj = e.changedTouches[0];
      this.dist = 0;
      this.touchOffset = this.currentOffset;
      this.startX = touchObj.pageX;
      this.startY = touchObj.pageY;
      const {xDiff,currentIndex,totalItems } = this;
      //console.log('touchStart',{touchObj,xDiff,currentIndex,totalItems});
    },
    touchMove(e) {
      var touchObj = e.changedTouches[0];
      let x = touchObj.pageX;
      let y = touchObj.pageY;
      this.xDiff = this.startX - x;
      let yDiff = this.startY - y;
      const {xDiff,currentIndex,totalItems } = this;

      if (this.xDiff > 0) {
        this.currentOffset = this.touchOffset - (this.xDiff);
      }
      // PREV
      else {
        this.currentOffset = this.touchOffset - (this.xDiff);
      }
    },
    touchEnd(e) {
      this.isTouched = false;
      this.touchOffset = 0;
      const {xDiff,currentIndex,totalItems } = this;
      //console.log('touchEnd',{xDiff,currentIndex,totalItems});
      if (xDiff == 0) return;
      if (xDiff > 0)
        {
          this.onNavigate(currentIndex != (totalItems - 1) ? ++this.currentIndex : currentIndex);
          this.xDiff = 0;
        }
      else
        {
          this.onNavigate(currentIndex != 0 ? --this.currentIndex : currentIndex);
          this.xDiff = 0;
        }
    },
    // URL PARAMETER OPERATIONS
    configureParameters() {
      let v = this.getUrlParameter('version');
      let lg = this.getUrlParameter('logo');
      let org = this.getUrlParameter('org');
      let color = this.getUrlParameter('color');
      this.logo = !lg || lg == 1 ? true : false; 
      
      this.org = org;
      if(v >= 0 && v <= 3) this.version  = v;
      this.color = !!color ? color : '1daf4c';
      let root = document.documentElement;
      root.style.setProperty('--brand-color', "#" + this.color);
      root.style.setProperty('--brand-color-darker', this.shadeColor("#" + this.color,-20));
      root.style.setProperty('--brand-color-dark', this.shadeColor("#" + this.color,-40));
    },
     shadeColor(color, percent) {

    var R = parseInt(color.substring(1,3),16);
    var G = parseInt(color.substring(3,5),16);
    var B = parseInt(color.substring(5,7),16);

    R = parseInt(R * (100 + percent) / 100);
    G = parseInt(G * (100 + percent) / 100);
    B = parseInt(B * (100 + percent) / 100);

    R = (R<255)?R:255;  
    G = (G<255)?G:255;  
    B = (B<255)?B:255;  

    var RR = ((R.toString(16).length==1)?"0"+R.toString(16):R.toString(16));
    var GG = ((G.toString(16).length==1)?"0"+G.toString(16):G.toString(16));
    var BB = ((B.toString(16).length==1)?"0"+B.toString(16):B.toString(16));

    return "#"+RR+GG+BB;
},
    getUrlParameter(param) {
      var url_string = window.location.href;
      var url = new URL(url_string);
      return url.searchParams.get(param);
    },
    daysLeft(val) {
      let today = moment();
      let next = moment.utc(val);
      let days = today.diff(next, 'days') + 1;
      if (days > 7) {
        let weeks = Math.ceil(days / 7);
        return `${weeks} weeks left`;
      }
      return `${days} day${days > 1 ? 's' : ''} left`;
    },
    formatNum(str) {
      str += '';
      return str.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    },
    formatDate(val) {
      return moment.utc(val).format('dddd, D MMMM YYYY');
    },
    formatTime(val) {
      return moment.utc(val).format('h:mm A');
    }
  }
}
</script>

<style lang="scss">
$bg-color: rgb(100,100,100);

body {
  margin: 0px;
}
@font-face {
  font-family: 'Roboto', sans-serif;;
  src: url('~@/assets/Roboto-Regular.ttf') format('truetype'); /* Chrome 4+, Firefox 3.5, Opera 10+, Safari 3—5 */
}  
#app {
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100vh;
  width: 100vw;
  // padding: 0px;
  // margin: 0px;
  position: relative;
}

.closed-raffle{
  background-color: rgb(91, 192, 222);
  border-radius: 4px;
  border-collapse: separate;
  box-sizing: border-box;
  color: rgb(255, 255, 255);
  display: inline;
  font-family: Roboto, Helvetica, Arial, sans-serif;
  font-size: 13.6px;
  font-weight: 400;
  height: "auto";
  line-height: 13.6px;
  padding: 4px 7px;
  text-align: center;
  text-indent: 0px;
  text-size-adjust: 100%;
  vertical-align: baseline;
  white-space: nowrap;
  width: auto;
  -webkit-border-horizontal-spacing: 0px;
  -webkit-border-vertical-spacing: 0px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.no-raffles{
    line-height: 67vh;
    margin: 0;
}
@media only screen and (max-width: 991px){
    p.drawdate {
        font-size: 14px !important;
    }
}

@media only screen and (max-width:767px){
    .no-raffles {
        line-height: 1.5em;
        text-align: center;
        padding: 15px;
    }
}
.header-text {
  position: relative;
  font-family: 'Open Sans', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 28px;
  line-height: 38px;
  text-align: center;
  text-transform: uppercase;
  color: #444444;
  margin-bottom: 2vh;
  margin-top: 0px;
  .carousel-v2 & {
    font-family: "Open Sans", Arial, sans-serif;
    // font-size: 21px;
    // font-weight: 500;
    // padding-bottom: 10px;
    // color: var(--brand-color);
    // margin-bottom: 0px;
    // line-height: 33px;
    // @media (min-width: 992px) {
    //   font-size: 30px;
    //   padding-bottom: 22px;
    // }          
  }
}



.header-ruler {
  width: 70px;
  height: 1px;
  margin-bottom: 7vh;
  background-color: #1DAF4C;
  .carousel-v2 & {
    border: 0px;
    background-color: var(--brand-color);
    // margin: 0;
    // background-color: #ababab;
    // border: 0px;
    // margin-bottom: 20px;
    // @media (min-width: 992px) {
    //   margin-bottom: 38px;
    // }
  }
}
.carousel-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  overflow-x: hidden;
  margin-left: auto;
  margin-right: auto;
  // width: 200vh;
  width: 100%;
  max-width: 100vw;

  // &--v2 {
  //   width: 100%;
  // }

  >div {
    overflow-x: hidden;
  }
}
.carousel-items-container {
  flex-grow: auto;
  display: flex;
  transform: translatex(0px);
}
.carousel-wrapper {
  padding-bottom: 5px;
  min-width: calc(100vw - 200px);
}
.carousel-item {
  background-color: #F7F7F7;
  box-shadow: 2px 3px 4px rgba(137, 137, 137, 0.2);
  position: relative;
  overflow: hidden;
  width: calc(100% / 3);
  min-width: calc(100% / 3.2);
  max-width: 394px;
  margin-right: calc(100% / 35);
  display: flex;
  flex-direction: column;
  cursor: pointer;

  // width: 100%;
  // min-width: 100%;
  // max-width: 440px;    
  .screen1100.total-slides1 & {
    width: 100%;
    min-width: 100%;    
    max-width: 500px;
    &:first-child, &:last-child {
     // margin: 0px !important;
    }
  }
  .screen1101.total-slides1 & {
    width: 100%;
    // min-width: 100%;      
    max-width: 500px;
    margin: auto  !important;
    // &:first-child, &:last-child {
    //   margin: 0px !important;
    // }
  }
  .screen1100.total-slides2 & {
    width: calc(100% / 2);
    min-width: calc(100% / 2.2);
    margin: auto  !important;
  }    
  .screen1101.total-slides2 & {
    width: calc(100% / 2);
    
    &:first-child {
      margin-left: calc(100%/3/2);
    }
   // min-width: calc(100% / 2.2);
  }  

  .carousel-item-inner {
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    height: calc(100% - 32px);
    margin: 16px;
    
  }
  .header {
    position: relative;
    width: 100%;

    .first-row {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 2.7vh;

      >img {
        max-width: 45%;
        height: 30px;
      }

      >div {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: bold;

        img {
          width: 18px;
          height: 20px;
          margin-right: 10px;
        }
        svg {
          color: var(--brand-color);
          width: 18px;
          height: 20px;
          margin-right: 10px;
        }        
      }
    }

    >.img {
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      width: 100%;
      // height: 29.5vh;
      // max-height: 236px;
      cursor: pointer;
      height: 0px;
      padding-top: 52%;
    }
    .info {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      width: calc(100% - (16px * 2));
      bottom: 0;
      margin: 16px;

      .info-item {
        display: flex;
        align-items: center;
        background-color: white;
        border-radius: 4px;
        padding: 0px 16px;
        height: 42px;

        p {
          font-family: 'Roboto', sans-serif;
          font-size: 20px;          
          margin-left: 10px;
          margin-top: 0px;
          margin-bottom: 0px;
          line-height: 28px;
        }
      }

      .info-item.first {
        padding: 0px;
        height: 42px;
        width: 42px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          height: 23px;
          width: 23px;
        }
      }

      .info-item.second {
        margin-left: auto;
      }
    }
  }

  p.title {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-size: 24px;
    line-height: 33px;
    height: 66px;
    margin: 2.8vh 0px 1vh 0px;
    color: #555555;
    text-overflow: 'ellipsis'; 
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -moz-box-orient: vertical;
    -ms-box-orient: vertical;
    box-orient: vertical;
    -webkit-line-clamp: 2;
    -moz-line-clamp: 2;
    -ms-line-clamp: 2;
    line-clamp: 2;
    overflow: hidden;
  }

  .sellings {
    display: flex;
    align-items: center;
    background-color: white;
    font-family: 'Roboto', sans-serif;
    font-style: normal;

    img {
      margin-right: 10px;
    }
    p {
      font-family: 'Roboto', sans-serif;
      font-size: 20px;
      margin: 0px;
    }
  }

 
    span.state-item-lists {
    margin-left: 4px;
}

  p.drawdate {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    margin-top: 0px;
    padding-top: 0px;
    font-weight: 600;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-top: 0;
  }

  p.description {
    position: relative;
    max-height: 87px; 
    overflow: hidden;
    text-overflow: 'ellipsis'; 
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -moz-box-orient: vertical;
    -ms-box-orient: vertical;
    box-orient: vertical;
    -webkit-line-clamp: 4;
    -moz-line-clamp: 4;
    -ms-line-clamp: 4;
    line-clamp: 4;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    line-height: 22px;
    color: #555555;
    margin: 0px 0px 2.5vh 0px;

    .showmore {
      cursor: pointer;
      display: block;
      position:absolute;
      // text-align: right;
      top: 65px;
      width: 100%;
      color: rgb(45, 154, 255);
      background-color: #F7F7F7;
    }
  }
  .carousel-content{
     height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .valid-states {
    font-size: 14px;
    font-weight: 700;
    margin: 1em 0;
  }

   .state-item-lists {
    color: #777;
    padding: 4px 1px;
    border-radius: 4px;
    margin-top: 4px;
    font-weight: 400;
    width: fit-content;
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    align-items: center;
  }
  
.single-state {
    border: 1px solid #999;
    width: 39px;
    height: 28px;
    position: relative;
    overflow: hidden;
    opacity: .7;
    border-radius: 4px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
}

.single-state:after, .single-state:before {
    position: absolute;
    content: "";
    left: -18px;
    width: 100px;
    height: 1px;
    background: #777;
    transform: rotate(33deg);
    top: 80%;
}

.single-state:before {
    transform: rotate(146deg) !important;
    top: 13px !important;
    left: auto !important;
    right: -30.5px;
    
}

.single-state.can-buy{
    background: #337ab7;
    color: #fff;
    opacity: 1;
    border-color: #337ab7;
}

.single-state.can-buy:before, .single-state.can-buy:after {
    background: transparent !important;
}

  a.item-link {
    
 
    button {
      font-size: 16px;
      padding: 10px;
      width: 100%;
      border: 0px;
      border-radius: 4px;
      cursor: pointer;
      color: white;
      outline: none;
      border: 2px solid var(--brand-color);
      background-color: var(--brand-color);
         -webkit-transition: all 0.1s ease-in-out;
        -moz-transition: all 0.1s ease-in-out;
        -o-transition: all 0.1s ease-in-out;
        transition: all 0.1s ease-in-out;
      &:hover{
        background-color:  var(--brand-color-darker);
      }
      &:active{
        background-color:  var(--brand-color-dark);
      }
    }

    &__lighter{ 

      button {
          outline: none;
         background-color: #fff;
         color: #777;
         border: 2px solid var(--brand-color);
        // background-color: mix(white, #4da9ee, 40%);
        // color: var(--brand-color);
        // background-color: white;
        &:hover{
         // color: var(--brand-color);
          background: #efefef;
        }
        &:active, &:focus{
         // color: var(--brand-color);
          background: #e6e6e6;
        }
      }
    }
  }

  .overlay {
    position: absolute;
    top: 0;
    height: 100%;
    max-height: 100%;
    width: 100%;
    max-width: 100%;
    background-color: white;
    transform: translateX(calc(-100%));
    transition: all 0.25s ease-out;

    .overlay-head {
      padding: 10px;
      border: 10px solid white;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      font-size: 20px;

      img {
        width: 25px;
        padding: 4px 10px;
        cursor: pointer;
        transition: all 0.25s;
      }
      img:hover {
        background-color: rgba(29, 175, 75, 0.089);
      }
    }

    .description {
      padding: 10px;
    }
  }

  .overlay.show {
    transform: translateX(0%);
  }

  // &--v2 {
  //   width: 100%;
  //   min-width: 100%;
  //   max-width: 440px;    
  //   .screen1100.total-slides1 & {
  //     width: 100%;
  //     min-width: 100%;
  //     max-width: 500px;
  //     &:first-child, &:last-child {
  //       margin: 0px !important;
  //     }
  //   }
  //   .screen1101.total-slides1 & {
  //     width: 100%;
  //     min-width: 100%;
  //     max-width: 500px;
  //     &:first-child, &:last-child {
  //       margin: 0px !important;
  //     }
  //   }
  //   .screen1100.total-slides2 & {
  //     width: calc(100% / 2);
  //     min-width: calc(100% / 2.2);
  //   }    
  //   .screen1101.total-slides2 & {
  //     width: calc(100% / 2);
  //     min-width: calc(100% / 2.2);
  //   }
  // }  

  &__img {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50%;
    width: 100%;
    height: 170px;
    cursor: pointer;
    @media (min-width: 992px) {
      height: 253px;
    }
  }

  &__info {
    padding: 10px 20px 15px;
    @media (min-width: 992px) {
      padding: 17px 30px 27px;
    }    
  }

  &__row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 13px;
    @media (min-width: 992px) {
      margin-bottom: 20px;
    }     
  }

  &__logo {
    height: 35px;
    max-width: 45%;
    @media (min-width: 992px) {
      height: 52px;
    }    
    img {
      height: 100%;
      width: auto;
      vertical-align: top;
    }
  }

  &__price {
    color: var(--brand-color);
    display: flex;
    align-items: center;
    font-size: 20px;
    font-weight: 700;
    @media (min-width: 992px) {
      font-size: 30px;
    }
  }

  &__price-icon {
    width: 34px;
    height: 21px;
    margin-right: 8px;
    @media (min-width: 992px) {
      width: 51px;
      height: 30px;
      margin-right: 11px;      
    }
  }

  &__title {
    color: #636363;
    font-size: 19px;
    line-height: 23px;
    font-weight: 400;
    margin: 0px 0px 10px;
    text-overflow: 'ellipsis'; 
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -moz-box-orient: vertical;
    -ms-box-orient: vertical;
    box-orient: vertical;
    -webkit-line-clamp: 2;
    -moz-line-clamp: 2;
    -ms-line-clamp: 2;
    line-clamp: 2;
    overflow: hidden;
    @media (min-width: 992px) {
      font-size: 28px;
      line-height: 34px;
      margin: 0px 0px 14px;
    }        
  }

  &__draw {
    color: #252525;
    font-size: 14px;
    line-height: 16px;
    font-weight: 700;
    margin: 0px 0px 10px;
    @media (min-width: 992px) {
      font-size: 21px;
      line-height: 24px;
      margin: 0px 0px 18px;
    }     
  }

  &__desc {
    color: #6d6d6d;
    font-size: 13px;
    line-height: 16px;
    margin: 0px;
    overflow: hidden;
    text-overflow: 'ellipsis'; 
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -moz-box-orient: vertical;
    -ms-box-orient: vertical;
    box-orient: vertical;
    -webkit-line-clamp: 4;
    -moz-line-clamp: 4;
    -ms-line-clamp: 4;
    line-clamp: 4;
    max-height: 64px;
    position: relative;
    @media (min-width: 992px) {
      font-size: 19px;
      line-height: 23px;
      max-height: 91px;
    }         
  }

  &__showmore {
    color: var(--brand-color);
    font-size: 13px;
    line-height: 16px;  
    text-decoration: underline;
    cursor: pointer;
    @media (min-width: 992px) {
      font-size: 19px;
      line-height: 23px;
    }       
  }

  &__buttons {
    margin: auto 24px 0px;
    @media (min-width: 992px) {
      margin: auto 58px 0px;
    }     
  }

  &__btn {
    user-select: none;
    background-image: none;
    touch-action: manipulation;
    cursor: pointer;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    display: block;
    text-decoration: none;

    height: 48px;
    padding: 0px 28px;
    line-height: 46px;
    background-color: var(--brand-color);
    color: #eeeff2;
    opacity: 1;
    transition: opacity 0.1s ease-in-out;
    border-radius: 24px;
    font-size: 15px;
    font-weight: 500;
    &:hover {
      color: #eeeff2;
      opacity: 0.8;
      outline: 0 !important;
    } 
    &:focus {
      outline: 0 !important;
    }
    @media (min-width: 992px) {
      height: 58px;
      line-height: 56px;
      font-size: 20px;
      border-radius: 29px;
    }       
  }
}
.carousel-box .carousel-item:first-child {
  margin-left: 0px;
}
.carousel-box .carousel-item:last-child {
  margin-right: 0px;
}
.carousel-action {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: #FFFFFF;
  border: 1px solid #999999;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 17px 20px;
  color: var(--brand-color);

  // .carousel-v2 & {
  //   background: transparent;
  //   border: 0px;
  //   padding: 0px;
  //   z-index: 10;
  //   color: var(--brand-color);
  //   &:focus {
  //     outline: none;
  //   }

  //   &.disable {
  //     opacity: 0.5;
  //   }
  // }
}
.carousel-action.disable {
  opacity: 0.2;
}
.carousel-action.prev{
  margin-right: 24px;
  margin-left: 24px;
  // .carousel-box--v2 & {
  //   margin-left: 24px;
  // }

  // .carousel-v2 & {
  //   margin: 0px 10px 0px 0px;
  //   left: 0px;
  //   .chevron-left {
  //     width: 28px;
  //     height: 28px;
  //     @media (min-width: 992px) {
  //       width: 46px;
  //       height: 46px;
  //     }       
  //   }    
  // }
}
.carousel-action.next{
  margin-left: 24px;
  margin-right: 24px;
  // .carousel-box--v2 & {
  //   margin-right: 24px;
  // }  

  // .carousel-v2 & {
  //   margin: 0px 0px 0px 10px;
  //   right: 0px;
  //   .chevron-right {
  //     width: 28px;
  //     height: 28px;
  //     @media (min-width: 992px) {
  //       width: 46px;
  //       height: 46px;
  //     }       
  //   }    
  // }  
}

/* Medium devices (landscape tablets, 768px and up) */
.screen1100 {

  .carousel-item {
    width: calc(100% / 2);
    min-width: calc(100% / 2.2);
    //width: 100%;
    //min-width: 100%;
    max-width: 100%;
    margin-right: calc(100% / 25);
    //margin: 0px !important;

    .header {

      // .first-row > img {
      //   // font-size: 15px;
      // }

      .info {
        width: calc(100% - (16px * 2));
        bottom: 0;
        margin: 16px;

        .info-item {
          border-radius: 4px;

          p {
            font-size: 15px;
            line-height: 28px;
          }
        }
      }
    }

    p.title {
      font-size: 18px;
      line-height: 25px;
      height: 50px;
    }

    .sellings {

      img {
        margin-right: 10px;
      }

      p {
        margin: 0px;
      }
    }

    p.description {
      color: #555555;
    }
  }
  .carousel-box .carousel-item:first-child {
    margin-left: calc(100% / 30);
  }
  .carousel-box .carousel-item:last-child {
    margin-right: calc(100% / 30);
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
.screen630{
  .carousel-box {
    width: calc(100vw - 10px);
    max-width: 400px;
    position: relative;
  }
  .carousel-item {
    width: 100%;
    // max-width: 394px;
    min-width: 100%;
    margin: 0px !important;

    .header {

      >.img {
        min-width: 264px;
      }

      .info {
        width: calc(100% - (16px * 2));
        bottom: 0;
        margin: 16px;

        .info-item {
          border-radius: 4px;
          padding: 0px 16px;
          height: 42px;

          p {
            font-size: 20px;
            line-height: 28px;
          }

          img {
            width: 18px;
            height: 20px;
          }
        }

        .info-item.first {
          height: 42px;
          width: 42px;
          padding: 0px;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 28px;
          }
        }
      }
    }

    p.title {
      font-size: 24px;
      line-height: 33px;
      height: 66px;
    }

    .sellings {
      font-size: 18px;
      line-height: 28px;

      img {
        margin-right: 10px;
      }

      p {
        margin: 0px;
        font-size: 20px;
        line-height: 28px;
      }
    }

    p.description {
      font-size: 16px;
      color: #555555;
    }
    .single-state {
      width: 36px;
    }
    .single-state:after{
      transform: rotate(36deg);
      top: 88%;
    }
    .single-state:before{
      transform: rotate(144deg)!important;
      top: 14px!important;
    }
    .state-item-lists{
        gap: 4px;
        padding: 4px 0;
    }
    // a.item-link {
    //   margin-bottom: 10px;
    // }
  }
}

// .screen1101 {
//   .carousel-item {
//     width: calc(100% / 3);
//     min-width: calc(100% / 3.2);
//   }
// }

.carousel-navigation {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0px;



  .nav-item {
    width: 10px;
    height: 10px;
    max-width: 10px;
    max-height: 10px;
    min-width: 2px;
    min-height: 2px;
    border-radius: 100%;
    background-color: #999999;
    margin: 0px 10px;
    cursor: pointer;
    transition: all 0.25s;

  }

    &__size-more-then-10{
      .nav-item{
        width: 7px;
        height: 7PX;
        margin: 0px 7px;
      }
    }

    &__size-more-then-15{
       .nav-item{
        width: 5px;
        height: 5PX;
        margin: 0px 5px;
      }
    }

  .nav-item.active {
    background-color: var(--brand-color);
  }
}
.visibility-hidden {
  visibility: hidden;
}

@media only screen and (max-height: 600px) {
  body, #app, .carousel-box {
    margin: 0px auto;
  }
  .carousel-box {
    width: 136vh;
    //width: 100%;
  }
  .header-text {
    font-size: 25px;
    margin-bottom: 0px;
  }
  .header-ruler {
    margin-bottom: 3vh;
  }
  .carousel-item {
    p.title {
      font-size: 20px;
      line-height: 28px;
      height: 56px;
      margin-top: 10px;
      margin-top: 10px;
    }
    .header .first-row {
      margin-bottom: 10px;

      > div span {
        font-size: 15px;
      }

      img {
        height: 27px;
      }
    }
  }
}

@media only screen and (min-height: 465px){
  .screen630 .carousel-box {
    max-width: unset !important;
  }
}
</style>
